// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"daaebe763839ab41","983":"f6a7ce5c5867b4a4"}[chunkId] + ".js";
};